import Crud from '@/views/Requirement/Crud'
import Add from '@/views/Requirement/Add'

const routes = {
  path: '/requirements',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/requirements',
      name: 'list-requirements',
      component: Crud,
    },
    {
      path: '/requirements/add',
      name: 'add-requirement',
      component: Add,
    },
    {
      path: '/requirements/edit/:id?',
      name: 'edit-requirement',
      component: Add,
    },
  ],
}

export default routes
